import React from 'react';
import { Trans } from 'react-i18next';

export const FLOW_TYPE_TO_EVENT_PROP = {
  EXTRA_BID: 'extra_bid',
  SINGLE_BID: 'pros_list',
  SINGLE_SELECT: 'single_select',
  MULTI_SELECT: 'multi_select',
  DIRECT_CONTACT: 'direct_booking',
  LEGACY: 'legacy'
};

export const JOB_CANCEL_REASONS = {
  i_wont_proceed: {
    slug: 'i_wont_proceed',
    literal: <Trans>T.JOB CANCEL REASON.not-proceed</Trans>
  },
  better_time_or_changed_plans: {
    slug: 'better_time_or_changed_plans',
    literal: <Trans>T.JOB CANCEL REASON.better-time-or-changed-plans</Trans>
  },
  seller_not_douleutaras: {
    slug: 'seller_not_douleutaras',
    literal: <Trans>T.JOB CANCEL REASON.seller-not-douleutaras</Trans>
  },
  other: {
    slug: 'other',
    literal: <Trans>T.JOB CANCEL REASON.other</Trans>
  }
};

export interface JobActionsConfig {
  canCancel: boolean;
  canUpdateStatus: boolean;
  canUpdateQuote: boolean;
  ccfNegativeFlowEnabled: boolean;
  seeCreditDetails: boolean;
}

export const JOB_ALLOWED_ACTIONS_BY_TYPE: Record<string, JobActionsConfig> = {
  DEFAULT: {
    canCancel: true,
    canUpdateStatus: true,
    canUpdateQuote: true,
    ccfNegativeFlowEnabled: true,
    seeCreditDetails: false
  },
  FIXED_PRICE: {
    canCancel: false,
    canUpdateStatus: false,
    canUpdateQuote: false,
    ccfNegativeFlowEnabled: false,
    seeCreditDetails: false
  },
  CREDIT_MODEL: {
    canCancel: false,
    canUpdateStatus: false,
    canUpdateQuote: false,
    ccfNegativeFlowEnabled: false,
    seeCreditDetails: true
  }
};

export default JOB_CANCEL_REASONS;
